import { PRODUCT_STATUS_AVAILABLE } from 'shared/consts'
import type { AlgoliaHits } from 'shared/utils/algolia/types'
import { getStatusByStatusReason } from 'views/utils/productStatusUtils'

export const isMultiVariantProduct = (
  product: AlgoliaHits,
  isMVExperimentEnabled: boolean
) => {
  const { variants = [], variant_attributes = [] } = product
  return (
    isMVExperimentEnabled &&
    variant_attributes.length > 1 &&
    variants.length > 1
  )
}

export const isAnyProductVariantAvailable = (product: AlgoliaHits) => {
  const { variants = [] } = product

  return (
    variants
      .map(v => getStatusByStatusReason(v.stock))
      .filter(status => status === PRODUCT_STATUS_AVAILABLE).length > 0
  )
}

export const findCheapestPriceFromMVProduct = (
  product: AlgoliaHits
): {
  listPrice: number | undefined
  retailPrice: number | undefined
  discountInPercent: number | undefined
} => {
  const cheapestVariant = product.variants
    .filter(v => v.stock === 'product.stockStatus.available')
    .sort((a, b) => a.retailPrice - b.retailPrice)[0]

  const cheapestRetailPrice = cheapestVariant?.retailPrice
  const cheapestListPrice = cheapestVariant?.listPrice
  const discountInPercent = cheapestVariant?.discount

  return {
    listPrice: cheapestListPrice,
    retailPrice: cheapestRetailPrice,
    discountInPercent,
  }
}
